

exports.__esModule = true;
exports.$ReviewRoute = undefined;

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _route = require('xo-wallet-components/src/confirm-upop/route');

var _route2 = _interopRequireDefault(_route);

var _route3 = require('xo-credit-components/src/apply-ppc/route');

var _route4 = _interopRequireDefault(_route3);

require('xo-login-components/src/onetouch-interstitial/route');

var _route5 = require('pages/xo-sidebar/route');

var _route6 = _interopRequireDefault(_route5);

var _route7 = require('pages/xo-sidepage/route');

var _route8 = _interopRequireDefault(_route7);

var _directive = require('./directive');

var _checkout = require('xo-models/src/checkout');

var _choice = require('xo-models/src/choice');

var _credit = require('xo-models/src/credit');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ReviewRoute = exports.$ReviewRoute = _squid.$ComponentRoute.extend('$ReviewRoute', {

    path: 'review',
    directive: _directive.$xoReviewPageComponent,
    titleContent: 'memberReview.memberReviewTitle',

    trackingData: {
        fptiState: 'review',
        templateName: 'memberReview.dust',
        pageGoal: 'Payment Review',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-review',
                'pagename2': '%::fullpage-review:member:hermes:',
                'version': 'member:%:'
            }
            // More page qualifiers come here...
        }
    },

    resolve: {
        action: function action($rootScope, $state) {
            // Determine if we should instead route to the selectFi choice experiment page
            if (!(0, _squid.$feature)('choiceExperiment')) {
                return;
            }

            var _$config$choiceExperi = _squid.$config.choiceExperiment;
            _$config$choiceExperi = _$config$choiceExperi === undefined ? {} : _$config$choiceExperi;
            var _$config$choiceExperi2 = _$config$choiceExperi.selectFi,
                fiPageVariants = _$config$choiceExperi2 === undefined ? [] : _$config$choiceExperi2,
                _$config$choiceExperi3 = _$config$choiceExperi.skipSelectFi,
                skipFiPageVariants = _$config$choiceExperi3 === undefined ? [] : _$config$choiceExperi3;
            var fromState = $state.fromState;

            var skipStates = ['checkout.selectFi', 'checkout.authorizationmessage', 'checkout.pageAddCard.addCardFlow.addCard', 'checkout.chooseCreditOffer'];

            if (!fromState.name || fromState.name.indexOf('checkout.review') !== -1 || skipStates.indexOf(fromState.name) !== -1) {
                return;
            }

            // If returning from credit application, skip the selectFi page
            var isCapeReturnKey = _credit.$CreditDataModel.instance($rootScope.token).getCapeKey();

            if (isCapeReturnKey) {
                return;
            }

            return _choice.$ChoiceEligibility.instance().getVariant($rootScope.token).then(function (variant) {
                // Check if variant is selectFi variant
                if (fiPageVariants.indexOf(variant) === -1) {
                    return;
                }

                var models = {};

                // Check that there is more than one plan to choose from, or that plan is not preferred
                return (0, _squid.$populate)(models, {
                    checkoutSession: _checkout.$CheckoutSessionModel.instance($rootScope.token)
                }).then(function () {
                    var plans = models.checkoutSession.get('fundingOptions.plans');
                    var isPreferredDefault = skipFiPageVariants.indexOf(variant) > -1 && plans && plans[0].primaryFs.isPreferred;
                    var stickyPlans = models.checkoutSession.futurePaymentInstruments;
                    if (!isPreferredDefault && (plans && plans.length > 1 || stickyPlans && stickyPlans.length > 1)) {
                        return {
                            to: 'checkout.selectFi',
                            newState: true
                        };
                    } else {
                        _logger.$logger.info('skip_selectFi', {
                            reason: isPreferredDefault ? 'default_is_preferred' : 'not_enough_plans'
                        });
                        return;
                    }
                });
            });
        }
    },

    children: [{
        route: _route6['default'],
        attributes: {
            'back-uri': 'backUri',
            'promotion': 'promotion',
            'update': 'update',
            'token': 'token',
            'installment': 'installment'
        }
    }, {
        name: '$OneTouchUpsellRoute',
        attributes: {
            'token': 'token',
            'on-complete': 'onComplete'
        }
    }, {
        route: _route2['default'],
        attributes: {
            'token': 'token',
            'cardmodel': 'cardModel',
            'on-success': 'onConfirmUpopSuccess',
            'on-cancel': 'onConfirmUpopCancel'
        }
    }, {
        route: _route4['default'],
        props: function props() {
            return {
                token: this.token
            };
        }
    }, {
        route: _route8['default'],
        props: function props() {
            return {
                token: this.token
            };
        }
    }]
});

angular.value("$ReviewRoute", $ReviewRoute);
_logger.$logger;

_squid.$ComponentRoute;

_squid.$feature;

_squid.$config;

_squid.$populate;

_directive.$xoReviewPageComponent;

_checkout.$CheckoutSessionModel;

_choice.$ChoiceEligibility;

_credit.$CreditDataModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-review/route.js
// module id = ./pages/xo-review/route.js
// module chunks = 1